<button
  (click)="action.emit()"
  class="flex items-center justify-between border-b-[1px] border-b-neutral-200 py-2 w-full"
  mat-ripple
>
  <div class="flex gap-x-3">
    @if (image) {
      <img [src]="image" loading="lazy" class="h-10 w-10 rounded-lg object-cover" alt="" />
    }
    <div class="text-sm text-start">
      <p>
        {{ title }}
      </p>
      <p class="font-semibold">
        {{ description }}
      </p>
    </div>
  </div>
  <mat-icon>
    <ng-content select="[icon]"></ng-content>
  </mat-icon>
</button>
